import React from 'react'
import ReactCountryFlag from 'react-country-flag'
import { CallOnShow } from '../calls/types'

type Props = {
  call: CallOnShow
}

export const LanguageIcon: React.FC<Props> = ({ call }) => {
  const country = (() => {
    switch (call.language) {
      case 1:
        return 'pl'
      case 2:
        return 'gb'
      case 3:
        return 'de'
      case 4:
        return 'ua'
    }
  })()

  return call.language && country ? (
    <>
      {' '}
      <ReactCountryFlag countryCode={country} svg className="flag" />
    </>
  ) : null
}
